import { makeVar } from "@apollo/client";
import { shouldMountLegacyTree } from "src/utils/dashboardVariant";

// True means the rebranded dashboard, which is the only tree users reach.
export const isNewDashboardVar = makeVar<boolean>(!shouldMountLegacyTree());
